import BaseBirthdateDropdown from 'registration/js/base/fields/birthdate_dropdown';

import template from 'registration/templates/new/fields/birthdate_dropdown.html';

const BirthdateDropdown = BaseBirthdateDropdown.extend({
    template,
    dropdownSelector: 'country-selector',
    classModifiersMap: {
        checked: 'selected',
    }
});

export default BirthdateDropdown;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/new/fields/birthdate_dropdown.js